import React, { useEffect } from 'react';
import './RolloverGuide.scss';
import { useSelector } from 'react-redux';
import { Direct } from './FundingType/Direct';
import { Indirect } from './FundingType/Indirect';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

function RolloverGuide() {
  const fundingType = useSelector(
    (state) =>
      state?.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreRollover?.onboardingRolloverType
  );
  useEffect(() => {
    dispatchPageLoad(
      fundingType === 'DIRECT' ? 'Guide Direct' : 'Guide Indirect'
    );
  }, [fundingType]);
  return (
    {
      DIRECT: <Direct />,
      INDIRECT: <Indirect />,
    }[fundingType] ?? <></>
  );
}

export default RolloverGuide;
